import styled from 'styled-components';

import { Box, Switcher as WikrSwitcher } from 'components/library';

import { color } from 'theme/selectors';

export const RadioContainer = styled(Box)`
    display: flex;
    justify-content: start;
    gap: 71px;

    ${({ $mb }) => Boolean($mb) && `margin-bottom: ${$mb}px;`};
    ${({ $paddingX }) => Boolean($paddingX) && `padding-left: ${$paddingX}px; padding-right: ${$paddingX}px;`};
    & label {
        color: ${color('text-secondary-subdued')};
    }
`;

// todo: remove after whiteSpace label issue for Swithcer component will be fixed:
// https://gitlab.asqq.io/vendor-react/components/-/issues/26
export const Switcher = styled(WikrSwitcher)`
    margin: 0;

    > label {
        white-space: nowrap;
    }
`;

export const ShortInputsWrapper = styled(Box)`
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding-bottom: 34px;

    > * {
        max-width: calc(50% - 8px);
    }
`;

export const InputWrapper = styled(Box)`
    & label {
        color: ${color('text-secondary-subdued')};
    }
`;
